<template>
  <b-button
    :size="size"
    :block="block"
    :variant="variant"
    :disabled="isDisabled"
    @click="onClick()"
  >
    <b-spinner small :class="spinnerClass" v-if="loading"/>
    <span v-else>
      {{label}}
    </span>
  </b-button>
</template>

<script>
export default {
  props: ['variant', 'label', 'block', 'loading', 'size'],

  methods: {
    onClick() {
      this.$emit('click');
    },
  },

  computed: {
    spinnerClass() {
      if (this.variant === 'primary' || this.variant === 'secondary') {
        return 'text-white';
      }

      return '';
    },

    isDisabled() {
      if (this.loading) {
        return true;
      }

      return this.disabled;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
